export default '#9676fb'
